<template>
  <v-ons-page id="detail_page">
    <Header :pageType="'detail'"></Header>
    <div id="detail_content">
      <div class="detail_content_inner">
        <div class="shop_name">
          <div class="shop_number" v-if="detailInfo.siten_flg">
            <span class="badge shop">店舗</span>
            <div>店番：{{detailInfo.rsv_t9}}</div>
          </div>
          <div class="shop_number" v-if="!detailInfo.siten_flg">
            <span class="badge atm">ATM</span>
          </div>
          <h1>{{detailInfo.tenpo}}</h1>
        </div>
        <ul class="attention" v-if="detailInfo.t_note1">
          <li>
            <a v-show="detailInfo.t_note1_link" :href="detailInfo.t_note1_link" target="_blank" v-html="$sanitize(detailInfo.t_note1)"></a>
            <span v-show="!detailInfo.t_note1_link" v-html="$sanitize(detailInfo.t_note1)"></span>
          </li>
        </ul>
        <div class="detail_information_wrapper">
          <dl v-if="detailInfo.address">
            <dt>住所</dt>
            <dd class="address">
              <div>
                <span class="postalcode" v-if="detailInfo.siten_flg">〒{{detailInfo.yuubin}}</span>
                {{detailInfo.address}}
              </div>
              <button type="button" class="map_button sp_none" id="open_map" @click="openMap()">
                <span>地図を表示</span>
                <img src="../assets/images/detail/map_button_arrow_down.svg" alt="地図を表示">
              </button>
              <a :href="encodeURL()" target="_blank" class="map_button pc_none">
                <span>Google Maps</span>
                <img src="../assets/images/detail/map_button_external.svg" alt="Google Maps">
              </a>
            </dd>
          </dl>
          <div class="opening_hours" v-if="openingHourCheck()">
            <dl class="counter_time" v-if="detailInfo.siten_flg">
              <dt>窓口営業時間</dt>
              <dd>
                <div class="opening_times" v-if="detailInfo.rsv_t4_rest">
                  <div class="days">平日</div>
                  <div class="times" v-html="$sanitize(detailInfo.rsv_t4_rest)"></div>
                </div>
                <div class="opening_times" v-if="detailInfo.saturday">
                  <div class="days">土曜</div>
                  <div class="times" v-html="$sanitize(detailInfo.saturday)"></div>
                </div>
                <div class="opening_times" v-if="detailInfo.sunday">
                  <div class="days">日曜</div>
                  <div class="times" v-html="$sanitize(detailInfo.sunday)"></div>
                </div>
                <div class="opening_times" v-if="detailInfo.holiday">
                  <div class="days">祝日</div>
                  <div class="times" v-html="$sanitize(detailInfo.holiday)"></div>
                </div>
                <p v-if="detailInfo.t_note2" v-html="$sanitize(detailInfo.t_note2)"></p>
                <!-- <div class="recommend_link">
                  <a href=""><span>新店舗詳細について</span></a>
                </div> -->
              </dd>
            </dl>
            <dl class="atm_time" v-if="detailInfo.day_normal || detailInfo.day_sat || detailInfo.day_sun || detailInfo.day_holiday">
              <dt>ATM営業時間</dt>
              <dd>
                <div class="opening_times" v-if="detailInfo.day_normal">
                  <div class="days">平日</div>
                  <div class="times" v-html="$sanitize(detailInfo.day_normal)"></div>
                </div>
                <div class="opening_times" v-if="detailInfo.day_sat">
                  <div class="days">土曜</div>
                  <div class="times" v-html="$sanitize(detailInfo.day_sat)"></div>
                </div>
                <div class="opening_times" v-if="detailInfo.day_sun">
                  <div class="days">日曜</div>
                  <div class="times" v-html="$sanitize(detailInfo.day_sun)"></div>
                </div>
                <div class="opening_times" v-if="detailInfo.day_holiday">
                  <div class="days">祝日</div>
                  <div class="times" v-html="$sanitize(detailInfo.day_holiday)"></div>
                </div>
                <p v-if="detailInfo.t_note3" v-html="$sanitize(detailInfo.t_note3)"></p>
                <!-- <div class="recommend_link">
                  <a href=""><span>新店舗詳細について</span></a>
                </div> -->
              </dd>
            </dl>
          </div>
          <dl v-if="detailInfo.parking">
            <dt>駐車場</dt>
            <dd v-if="detailInfo.parking">あり<br><span v-if="detailInfo.parking_note">{{detailInfo.parking_note}}</span></dd>
            <dd v-if="!detailInfo.parking">なし</dd>
          </dl>
          <!-- <dl v-if="servicesCheck()"> -->
          <dl class="service" v-if="servicesCheck()">
            <dt>サービス</dt>
            <dd class="service_icons">
              <img src="../assets/images/detail/service_currency.svg" alt="外貨両替" @click="setIconKind('外貨両替')" v-if="detailInfo.gaika_ryogae">
              <img src="../assets/images/detail/disabled_currency.svg" alt="外貨両替" @click="setIconKind('外貨両替')"  v-if="!detailInfo.gaika_ryogae">
              <img src="../assets/images/detail/service_remittance.svg" alt="外国送金" @click="setIconKind('外国送金')"  v-if="detailInfo.gaikoku_sokin_flg">
              <img src="../assets/images/detail/disabled_remittance.svg" alt="外国送金" @click="setIconKind('外国送金')"  v-if="!detailInfo.gaikoku_sokin_flg">
              <img src="../assets/images/detail/service_bankbook.svg" alt="通帳取扱ATM" @click="setIconKind('通帳取扱')"  v-if="detailInfo.chucho_toriatukai">
              <img src="../assets/images/detail/disabled_bankbook.svg" alt="通帳取扱ATM" @click="setIconKind('通帳取扱')"  v-if="!detailInfo.chucho_toriatukai">
              <img src="../assets/images/detail/service_carry_atm.svg" alt="通帳繰越ATM" @click="setIconKind('通帳繰越')"  v-if="detailInfo.chucho_flg">
              <img src="../assets/images/detail/disabled_carry.svg" alt="通帳繰越ATM" @click="setIconKind('通帳繰越')"  v-if="!detailInfo.chucho_flg">
              <img src="../assets/images/detail/service_transfer.svg" alt="現金振込ATM" @click="setIconKind('現金振込')"  v-if="detailInfo.genkin_hurikomi">
              <img src="../assets/images/detail/disabled_transfer.svg" alt="現金振込ATM" @click="setIconKind('現金振込')"  v-if="!detailInfo.genkin_hurikomi">
              <img src="../assets/images/detail/service_coin.svg" alt="硬貨入出金ATM" @click="setIconKind('硬貨入出金')"  v-if="detailInfo.kouka_nyusyutu">
              <img src="../assets/images/detail/disabled_coin.svg" alt="硬貨入出金ATM" @click="setIconKind('硬貨入出金')"  v-if="!detailInfo.kouka_nyusyutu">
              <img src="../assets/images/detail/service_voice_atm.svg" alt="音声案内ATM" @click="setIconKind('音声案内')"  v-if="detailInfo.disabilities_flg">
              <img src="../assets/images/detail/disabled_voice.svg" alt="音声案内ATM" @click="setIconKind('音声案内')"  v-if="!detailInfo.disabilities_flg">
            </dd>
          </dl>
          <dl>
            <dt class="sp_none"></dt>
            <dd class="service_info">
              <p>アイコンをクリックすると説明をご覧いただけます。</p>
            <div  v-if="clickIconKind==='外貨両替'">
              <div class="icon_info">
                <img src="../assets/images/detail/service_currency.svg"/>
                <span class="icon_title">外貨両替</span>
              </div>
              <p>外貨両替取扱店です。</p>
            </div>
            <div  v-if="clickIconKind==='外国送金'">
              <div class="icon_info">
                <img src="../assets/images/detail/service_remittance.svg"/>
                <span class="icon_title">外国送金</span>
              </div>
              <p>外国送金取扱店です。</p>
            </div>
            <div  v-if="clickIconKind==='通帳取扱'">
              <div class="icon_info">
                <img src="../assets/images/detail/service_bankbook.svg"/>
                <span class="icon_title">通帳取扱</span>
              </div>
              <p>通帳を利用できるATMを設置しています。</p>
            </div>
            <div  v-if="clickIconKind==='通帳繰越'">
              <div class="icon_info">
                <img src="../assets/images/detail/service_carry_atm.svg"/>
                <span class="icon_title">通帳繰越</span>
              </div>
              <p>通帳の繰越ができるATMを設置しています。<br/>※ 一部お取扱いができない通帳があります。</p>
            </div>
            <div  v-if="clickIconKind==='現金振込'">
              <div class="icon_info">
                <img src="../assets/images/detail/service_transfer.svg"/>
                <span class="icon_title">現金振込</span>
              </div>
              <p>
                現金で振込ができるATMを設置しています。<br/>
                ＜最長ご利用可能時間＞<br/>
                &emsp;平   日&emsp;7：00～23：00<br/>
                &emsp;土日祝&emsp;8：45～21：00<br/>
                &emsp;※ ATMコーナーごとに営業時間が異なります。
              </p>
            </div>
            <div  v-if="clickIconKind==='硬貨入出金'">
              <div class="icon_info">
                <img src="../assets/images/detail/service_coin.svg"/>
                <span class="icon_title">硬貨入出金</span>
              </div>
              <p>
                硬貨の入出金ができるATMを設置しています。<br/>
                ＜最長ご利用可能時間＞<br/>
                &emsp;平   日&emsp;8：45～18：00<br/>
                &emsp;※ ATMコーナーごとに営業時間が異なります。<br/>
              </p>
            </div>
            <div  v-if="clickIconKind==='音声案内'">
              <div class="icon_info">
                <img src="../assets/images/detail/service_voice_atm.svg"/>
                <span class="icon_title">音声案内</span>
              </div>
              <p>音声ガイダンスを利用できるATMを設置しています。</p>
            </div>
            
          <p>※「／」表示のサービス・設備はお取り扱いがございませんので、ご注意ください。</p>
            </dd>
          </dl>

        </div>
        <div class="remarks" v-if="detailInfo.t_note4">
          <div class="remarks_title">備考</div>
          <p v-html="$sanitize(detailInfo.t_note4)"></p>
        </div>
        <div class="detail_information_wrapper">
          <dl class="phone " v-if="detailInfo.tel">
            <dt>電話番号</dt>
            <dd class="phone_number">
              <div class="pc_phone_number sp_none">{{detailInfo.tel}}</div>
              <a :href="telLink" class="pc_none">{{detailInfo.tel}}</a>
              <span class="caption" v-if="detailInfo.t_note5">{{detailInfo.t_note5}}</span>
            </dd>
          </dl>
        </div>
        <div class="pr" v-if="detailInfo.asset_msg">
          <div class="pr_text">口座開設・相続発生後のお手続き、<br/>資産運用のご相談は、ネット予約がおススメ！</div>
          <div class="pr_button">
            <div class="web_reserve">
              <a href="https://www2.ncbank.co.jp/fa_user/consult/first" target="_blank">
                <img src="../assets/images/detail/reserve_web_icon.svg" alt="Webで来店予約">
                <span>Webで来店予約</span>
              </a>
            </div>
            <div class="telephone_reserve pc_none">
              <a :href="telLink">
                <img src="../assets/images/detail/reserve_phone_icon.svg" alt="電話でお問い合わせ">
                <span>電話でお問い合わせ</span>
              </a>
            </div>
          </div>
        </div>
        <div id="map_container" v-show="isOpenMap">
          <div id="place_map" class="place_map sp_none" ref="place_map"></div>
          <div class="map_button zoom">
            <button type="button" @click="mapZoom('plus')">
              <img src="../assets/images/map/zoom_plus.svg" alt="ズームイン">
            </button>
            <hr>
            <button type="button" @click="mapZoom('minus')">
              <img src="../assets/images/map/zoom_minus.svg" alt="ズームアウト">
            </button>
          </div>
        </div>
      </div>
      <BreadCrumb :crumbPages="pages"></BreadCrumb>
      <Footer></Footer>
    </div>
  </v-ons-page>
</template>

<script>
import _ from 'lodash';
import $ from "jquery";
import Header from './partial/header.vue';
import BreadCrumb from './partial/breadCrumb.vue';
import Footer from './partial/footer.vue';

import { Loader } from '@googlemaps/js-api-loader';

import ApiService from '../services/api-service.js';
import ConfigService from '../services/config-service.js';

export default {
  name: 'Detail',
  components: {
    Header,
    BreadCrumb,
    Footer,
  },
  props: [],
  data() {
    return {
      isCurrentRoute: this.$router.currentRoute.name === this.$options.name ? true : false,
      isOpen: false,
      pages: [],
      detailInfo: [],
      telLink: '',
      isOpenMap: false,
      clickIconKind:"",

      // Google Map関連
      googleMap: null,
      google: null, // load callback google object
      atmPinImage: require("@/assets/images/map/atm_pin.svg"),
      shopPinImage: require("@/assets/images/map/shop_pin.svg"),
    }
  },
  watch: {
  },
  methods: {
    popPage() {
      this.$router.back();
    },
    liftDown() {
      this.positionY = 0;
      this.isListOpen = false;
    },
    /**
     * サービスの存在をチェックします
     */
    servicesCheck() {
      const serviceArray = [
        this.detailInfo.chucho_flg,
        this.detailInfo.disabilities_flg,
        this.detailInfo.gaika_ryogae,
        this.detailInfo.gaikoku_sokin,
        this.detailInfo.genkin_hurikomi,
        this.detailInfo.chucho_toriatukai,
        this.detailInfo.kouka_nyusyutu
      ];
      return true;
    },
    /**
     * 営業時間の存在をチェックします
     */
    openingHourCheck() {
      const openingHourArray = [
        this.detailInfo.rsv_t4_rest,
        this.detailInfo.saturday,
        this.detailInfo.sunday,
        this.detailInfo.holiday,
        this.detailInfo.t_note2,
        this.detailInfo.day_normal,
        this.detailInfo.day_sat,
        this.detailInfo.day_sun,
        this.detailInfo.day_holiday,
        this.detailInfo.t_note3
      ];
      return _.some(openingHourArray);
    },
    openMap() {
      this.isOpenMap = true;
      this.$nextTick(() => {  
        const target = this.$refs.place_map;
        const position = $(target).offset().top;
        $('ons-page#detail_page .page__content').animate({
          scrollTop: position
        }, 300, 'swing');

        const loader = new Loader({
          apiKey: ConfigService.getMapApiKey(),
          version: "weekly"
        });

        const mapOptions = {
          center: {lat: Number(this.detailInfo.latitude), lng: Number(this.detailInfo.longitude)},
          zoom: 16,
          disableDefaultUI: true,
          mapId: '4e1bb28009b7a7cb'
        };

        loader.load()
          .then(async (google) => {
            this.google = google;
            this.googleMap = new this.google.maps.Map(this.$refs.place_map, mapOptions);
            let iconImage = this.detailInfo.siten_flg ? this.shopPinImage : this.atmPinImage;
            let iconImageObject = {
              url: iconImage,
              scaledSize: new this.google.maps.Size(32, 40),
              // origin: new this.google.maps.Point(0,0), // origin
              // anchor: new this.google.maps.Point(0,0)
            };

            new this.google.maps.Marker({
              position: {'lat': Number(this.detailInfo.latitude), 'lng': Number(this.detailInfo.longitude)},
              map: this.googleMap,
              icon: iconImageObject,
            });
          }).catch(error => {
            console.log(error);
          });
      });
    },
    /**
     * マップをズームイン・ズームアウトします
     */
    mapZoom(zoom) {
      let currentZoomLevel = this.googleMap.getZoom();
      let zoomLevel;
      if (zoom === 'plus') {
        zoomLevel = ++currentZoomLevel;
      } else {
        zoomLevel = --currentZoomLevel;
      }
      this.googleMap.setZoom(zoomLevel);
    },
    /**
     * アイコンの説明を表示する種別を操作します
     */
    setIconKind(kind){
      this.clickIconKind=kind;
    },
    /**
     * URLをエンコードします
     */
    encodeURL() {
      // return `http://maps.google.com/maps?q=${this.detailInfo.latitude},${this.detailInfo.longitude}+${this.detailInfo.tenpo}`;
      return encodeURI(`https://www.google.com/maps/search/?api=1&query=${this.detailInfo.latitude},${this.detailInfo.longitude}`);
    },
  },
  created: function() {
    const id = this.$route.params.id;
    const param = {
      'id': id
    }
    ApiService.detail(param)
      .then(data => {
        this.detailInfo = data.info;
        // 電話番号
        this.telLink = `tel:${this.detailInfo.tel}`;

        this.pages = [
          {'name': 'トップ', 'url': 'https://www.ncbank.co.jp/'},
          {'name': '店舗・ATM検索', 'url': '/atm/'},
          {'name': this.detailInfo.tenpo, 'url': this.detailInfo.id},
        ];

        if (this.$gtm.enabled()) {
          this.$gtm.trackEvent({
            event: 'show_detail',
            action: 'show',
            category: 'detailVariable',
            label: '表示店舗ATM',
            value: `${this.detailInfo.tenpo} 店番: ${id}`
          })
        }
      }, error => {
        console.log(error);
      });

    
  },
  mounted: function() {
  },
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/detail.scss";
</style>